import { render, staticRenderFns } from "./definition-de-merch.vue?vue&type=template&id=0f735009&"
import script from "./definition-de-merch.vue?vue&type=script&lang=js&"
export * from "./definition-de-merch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports